<button
  (click)="toggleMenu()"
  (rdClickOutside)="closeMenu()"
  type="button"
  class="header-profile-points-balance flex cursor-pointer items-center justify-end text-base focus-link"
  *ngIf="pointsSummaryFacade.pointsSummary$ | async as pointSummary">
  {{ 'wl.star.header.you_have_points' | translate }}
  <strong> {{ pointSummary.pointsBalance | localizePointsNumber }} </strong>
  <strong
    *ngIf="
      loyaltyCurrencyFacade.getLoyaltyCurrencySelected$
        | async as loyaltyCurrency
    ">
    {{ loyaltyCurrency.name }}
  </strong>
  <rd-shared-icon
    class="icon-chevron inline-flex transform transition duration-300"
    [ngClass]="{ 'menu-expanded': menuExpanded }"
    [iconSymbol]="'icon-chevron-down-white'"></rd-shared-icon>
</button>
<ul
  class="header-profile-menu shadow-xl typo-small-text-desktop"
  *ngIf="menuExpanded">
  <li class="pt-4 pb-2 pl-6 pr-4">
    <a
      class="header-profile-menu-link focus-link"
      [routerLink]="'/points_activity'"
      >{{ 'wl.star.header.points_activity' | translate }}</a
    >
  </li>
  <li class="py-2 pl-6 pr-4">
    <button
      type="button"
      class="header-profile-menu-link typo-small-text-desktop focus-link"
      (click)="userActionEvent.emit('changePassword')">
      {{ 'wl.star.header.change_password' | translate }}
    </button>
  </li>
  <li class="pt-2 pb-4 pl-6 pr-4">
    <button
      type="button"
      class="header-profile-menu-link inline-flex items-center typo-small-text-desktop focus-link"
      (click)="userActionEvent.emit('logout')">
      <rd-shared-icon
        class="icon-logout mr-2 inline-block"
        [iconSymbol]="'icon-logout'"
        [iconTheme]="'link'"></rd-shared-icon>
      {{ 'wl.star.header.log_out' | translate }}
    </button>
  </li>
</ul>
